module.exports = __webpack_public_path__ + "static/Noon-Logo-PNG-512.cb24b124.png";